import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {themeTypes} from "app/models";
import {ThemeColorsService} from "app/services/theme/themeColors.service";
import {ThemeTypographyService} from "app/services/theme/themeTypography.service";
import {Theme} from "@material-ui/core";


// Define a type for the slice state
interface AppInitSlice {
    theme: any,
    isLoading: boolean
}

// Define the initial state using that type
const initialState: AppInitSlice = {
    theme: {
        palette: ThemeColorsService.getThemeDefaults(themeTypes.outlinedDark, false),
        type: themeTypes.light,
        defaultColors: true,
        typography: ThemeTypographyService.getThemeDefaults()
    },
    isLoading: false,
}

export const appInitSlice = createSlice({
    name: 'nbiConnectInit',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        setDefaultTheme: (state, action: PayloadAction<Theme>) => {
            state.theme = action.payload;
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    }
})

export const {setDefaultTheme, setIsLoading} = appInitSlice.actions

// Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default appInitSlice.reducer
